export const TITLE_AGUA_DULCE = "Agua Dulce -";
export const TITLE_AGUA_MAR = "Aguamar -";
export const TITLE_PROCESOS = "Procesos -";
export const TITLE_Administracion = "Administracion -";
export const TITLE_INSPECCION = "inspeccion";
